module.exports = __webpack_public_path__ + "static/img/reactBack.beb9418.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/reactBack.png
// module id = Uz1j
// module chunks = 10